export const getImageFromSteamWithCustomSize = (
  steamImagePath: string,
  width: number = 186,
  height: number = 186
) => {
  return `${steamImagePath}/${width}fx${height}`;
};
